var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"header"},[_c('ButtonOpenFbConversation',{attrs:{"user-id":_vm.user.id,"v-btn-props":{
        dark: true,
        small: true,
        outlined: true
      }}}),_vm._v(" "),_c('span',{staticClass:"ml-3 text-no-wrap"},[_vm._v("ID FB : "+_vm._s(_vm.user.facebook_id))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }